import React from 'react'
import { useLocation } from 'react-router-dom'
import { Flex } from '../Box'
import isTouchDevice from '../../util/isTouchDevice'
import DropdownMenu from '../DropdownMenu/DropdownMenu'
import MenuItem from '../MenuItem/MenuItem'
import IconComponent from '../Svg/IconComponent'
import { MenuItemsProps } from './types'

const MenuItems: React.FC<MenuItemsProps> = ({ items = [], ...props }) => {
  const { pathname } = useLocation()
  return (
    <Flex {...props}>
      {items.map(({ label, items: menuItems = [], href, icon = '' }) => {
        const statusColor = menuItems?.find((menuItem) => menuItem.status !== undefined)?.status?.color
        const isActive = menuItems.some((item) => item.href === pathname) || href === pathname
        const linkProps = isTouchDevice() && menuItems && menuItems.length > 0 ? {} : { href }
        return (
          <DropdownMenu key={`${label}#${href}#${icon}`} items={menuItems}>
            <MenuItem {...linkProps} isActive={isActive} statusColor={statusColor}>
              {label || <IconComponent iconName={icon} color={isActive ? 'secondary' : 'textSubtle'} />}
            </MenuItem>
          </DropdownMenu>
        )
      })}
    </Flex>
  )
}

export default MenuItems
